import { formatSummaryLabel, isUsefulSummaryValue } from '../lib/patientReport';

export const PatientSummaryCards = ({ summaries = [], loading = false, error = null }) => {
    const priorityFields = [
        'center',
        'site',
        'age',
        'sex',
        'gender',
        'epilepsy_type',
        'epilepsy',
        'lesional',
        'engel',
        'engel_outcome',
        'outcome'
    ];

    if (loading) {
        return <div className="patient-summary-empty">Loading patient metadata...</div>;
    }

    if (error) {
        return <div className="patient-summary-empty error">Patient metadata unavailable: {error}</div>;
    }

    if (!summaries.length) {
        return <div className="patient-summary-empty">Select a patient to view metadata.</div>;
    }

    return (
        <div className="patient-summary-list">
            {summaries.map(summary => {
                const visibleEntries = priorityFields
                    .filter(key => isUsefulSummaryValue(summary[key]))
                    .map(key => [key, summary[key]]);
                const clinicalLabels = summary.clinical_labels || {};

                return (
                    <div className="patient-summary-card" key={summary.patient_id}>
                        <div className="patient-summary-title">{summary.patient_id}</div>
                        <div className="patient-summary-grid">
                            {visibleEntries.slice(0, 8).map(([key, value]) => (
                                <div className="patient-summary-row" key={key}>
                                    <span>{formatSummaryLabel(key)}</span>
                                    <strong>{String(value)}</strong>
                                </div>
                            ))}
                        </div>
                        {Object.keys(clinicalLabels).length > 0 && (
                            <div className="patient-summary-labels">
                                {Object.entries(clinicalLabels)
                                    .filter(([, value]) => Number(value) > 0)
                                    .map(([key, value]) => (
                                        <span key={key}>{formatSummaryLabel(key)}: {value}</span>
                                    ))}
                            </div>
                        )}
                    </div>
                );
            })}
        </div>
    );
};
